import api from "../instance/axios_instance.ts";
import { ManagementInterface } from "../interface/managementInterface";
export const UpdateManagement = async (data: ManagementInterface): Promise<ManagementInterface> => {

    try {
        const response = await api.put<ManagementInterface>('/update_management', data);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }

};

export default UpdateManagement;